import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ServiceServiceAreasIndication implements IController {
  service: any;
  maxItems: any;

  public areaNames: any[];

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    const tasks = _.get(this.service, 'taskList', []);
    this.areaNames = _.chain(tasks)
      .map(t => {
        const areasMap = _.get(t, 'taskSpec.address.areaIdToNameMap');
        return !!areasMap ? _.map(_.get(t, 'taskSpec.address.areaIdToNameMap', {}),  (value, key) => {
          return value;
        }) : undefined;
      })
      .compact()
      .flatMap()
      .uniq()
      .value();

    if (!this.maxItems) {
      this.maxItems = 3;
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.service && !changes.service.isFirstChange()) {
      this.$onInit();
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceServiceAreasIndication', {
    bindings: {
      service: '<',
      maxItems: '<?'
    },
    template: require('./service-service-areas-indication.html').default,
    controller: ServiceServiceAreasIndication
  });
